import styled from '@emotion/styled';

import Link from 'components/Link';

export const StyledLink = styled(Link)`
  display: inline-block;
  margin: 3px 5px;
  padding: 2px 10px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.secondary.black};
  background-color: ${({ theme }) => theme.colors.secondary.paleGray};
`;
